import { MDSLensGroupItem } from "@/mds/components/lens-group/lens-group-item";
import { MDSLensGroupProps } from "@/mds/components/lens-group/lens-group.types";
import styled from "@emotion/styled";

export const MDSLensGroup = ({ items }: MDSLensGroupProps) => {
  return (
    <Wrapper>
      {items.map((item, index) => (
        <MDSLensGroupItem key={index} {...item} />
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  padding-inline: ${({ theme }) => theme.spacing["1"]};
`;
